import httpManager from "@/app/shared/utils/httpManager";

export async function fetchTtsPricing({ model, voice }) {
  const query = new URLSearchParams({
    model,
    voice,
  }).toString();
  const response = await httpManager.get(`/strategies/tts-pricing/?${query}`);
  return response?.data;
}
